  (function() {
    function initTestimonialSlider(section) {
      const carousel = section.querySelector('.swiper-testimonial');
      if (!carousel || carousel.classList.contains('swiper-initialized')) return;

      const scrollbar = section.querySelector('.swiper-scrollbar');
      if (!scrollbar) return;
      // CSS-based activation (optional - always enabled for now)
      const computedContent = window.getComputedStyle(carousel, '::after').getPropertyValue('content');
      
      // Init Swiper
      const swiperInstance = new Swiper(carousel, {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        scrollbar: {
          el: '.swiper-scrollbar',
        }
      });

      carousel.swiperInstance = swiperInstance;
    }

    function destroyTestimonialSlider(section) {
      const carousel = section.querySelector('.swiper-testimonial');
      if (carousel?.swiperInstance) {
        carousel.swiperInstance.destroy(true, true);
        carousel.swiperInstance = null;
      }
    }

    function setupTestimonialSlider() {
      document.querySelectorAll('.bd-testimonial-section').forEach(section => {
        const carousel = section.querySelector('.swiper-testimonial');
        if (!carousel) return;

        const isEnabled = carousel.classList.contains('swiper-initialized');

        if (!isEnabled) {
          initTestimonialSlider(section);
        }
      });
    }

    // DOM Ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupTestimonialSlider);
    } else {
      setupTestimonialSlider();
    }


    var resizeRunning = false;

    window.addEventListener('resize', () => {
      if (resizeRunning) return;
      resizeRunning = true;

      requestAnimationFrame(() => {
        setupTestimonialSlider();
        resizeRunning = false;
      });
    });

    // Shopify Events
    document.addEventListener('shopify:section:load', e => {
      const section = document.querySelector(`.bd-testimonial-section[data-section-id="${e.detail.sectionId}"]`);
      if (section) {
        const waitForDOM = () => {
          // Only init when section is actually painted and visible
          if (document.body.contains(section)) {
            requestAnimationFrame(() => setupTestimonialSlider(section));
          } else {
            requestAnimationFrame(waitForDOM);
          }
        };
        requestAnimationFrame(waitForDOM);
      }
        
    });

    document.addEventListener('shopify:section:unload', e => {
      const section = document.querySelector(`.bd-testimonial-section[data-section-id="${e.detail.sectionId}"]`);
      if (section) destroyTestimonialSlider(section);
    });

    document.addEventListener('shopify:theme-settings:updated', setupTestimonialSlider);
  })();